module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row csp-card",
    attrs: {
      "id": "Workflow"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.heading !== undefined) ? _c('div', {
    staticClass: "row csp-margin-top"
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 "
  }, [_c('p', {
    staticClass: "csp-account-id"
  }, [_vm._v(_vm._s(_vm.heading))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block container-fluid"
  }, [(_vm.backRoute !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 csp-back-link-container"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "csp-back-link-text",
    attrs: {
      "to": _vm.backRoute
    }
  }, [_vm._v(_vm._s(_vm.backNavLink))])], 1)]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.allInputValid || _vm.loading),
      expression: "!allInputValid || loading"
    }],
    staticClass: "btn btn-disabled csp-btn-continue"
  }, [_c('span', [_vm._v(_vm._s(_vm.navButton))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allInputValid && !_vm.loading),
      expression: "allInputValid && !loading"
    }]
  }, [_c('router-link', {
    staticClass: "btn btn-primary primary-color csp-btn-continue",
    attrs: {
      "to": _vm.nextRoute
    }
  }, [_vm._v(_vm._s(_vm.navButton))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('progress-dots', {
    attrs: {
      "totalSteps": _vm.workflowSteps,
      "currentStep": _vm.currentStep
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05dccc13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Workflow.vue
// module id = 848
// module chunks = 2